<div *ngIf="!test&&!showNext" class="outside-container " >
    <div >
        <div class="container">
          <div  class="stepper-container">
            <div class="steps">
              <div class="step" (click)="stepClick(3)" [class.active]="currentStep === 3"> <mat-icon style="font-size: 17px;padding-top: 8px;">book</mat-icon>Review</div>

              <div class="step"  (click)="!acknowledge&&stepClick(1)" [class.active]="currentStep === 1"><mat-icon style="font-size:17px; padding-top: 8px;">payments</mat-icon>Payment & Booking</div>
              <!-- <div class="step" [class.active]="currentStep === 2"> <mat-icon style="font-size: 17px;padding-top: 8px;">book</mat-icon>Ticket Detail</div> -->
              <!-- <div class="step" [class.active]="currentStep === 3"><mat-icon style="font-size: 17px; padding-top: 8px;">print</mat-icon>Print Detail</div> -->
            </div>
          
            <div class="step-content">
              <!-- Content for each step goes here -->
              <!-- <div *ngIf="currentStep === 1">Payment Detail Content</div>
              <div *ngIf="currentStep === 2">Booking Content</div>
              <div *ngIf="currentStep === 3">Print Detail Content</div> -->

              <div class="col-md-12">
                <form >
                  <div *ngIf="currentStep === 3" style="height: 50vh;overflow: auto;">
                    <span class="d-flex justify-content-start" style="color: rgb(153, 145, 145);">
                      {{orderId?.hotelDetail?.name}}&nbsp; 
                      <small *ngFor="let start of starArray(orderId?.repriceData?.selectedHotelOrder?.hotel?.ratings[0]?.starRating)"> 
                        <img  src="../../../assets/images/star.png" width="18" height="18" alt="">
                        </small>
                      
                  </span>

                      <div class="hotel-details">
                      <p style="text-align: left;">
                          {{orderId?.hotelDetail?.location}} 
                            Postal Code: {{orderId?.hotelDetail?.pinCode}}</p>
                          <!-- <a href="#" class="back-link">Back to hotel details</a> -->
                          <div class="details">
                            <div class="detail">
                              <h2>Check In</h2>
                              <p>{{orderId?.searchDetail?.checkInDate}}</p>
                            </div>
                            <div class="detail">
                              <h2>Check Out</h2>
                              <p>{{orderId?.searchDetail?.checkOutDate}}</p>

                            </div>
                            <div class="detail">
                              <h2>Total Rooms</h2>
                              <p>{{orderId?.searchDetail?.roomCount}}</p>
                            </div>
                            <div class="detail">
                              <h2>Total Guest</h2>
                              <p>{{orderId?.searchDetail?.adultCount+orderId.searchDetail?.childCount}}</p>
                            </div>
                          </div>
                        </div>
                    

                        <div class="col-md-12 mt-3" >
                        
                          <!-- <table class="styled-tables ">
                              <thead>
                                <tr >
                                  <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> hotel</mat-icon>Room Type
                                  </th>
                                  <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Meal Plan</th>
                                  <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> groups</mat-icon>Guest Name  </th>
                                  
                                 
      
      
                                </tr>
                              </thead>
                              <tbody>
      
                                
                                <tr *ngFor="let con of orderId.travellerDetails; let i=index">
                                  <td class=""style="padding: 8px;  text-align: center;" >
                                
                                    {{orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms[0]?.name}}
                                  </td>
                                     <td class=""style="padding: 8px;  text-align: center;" >
                                      
                                        {{orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms[0]?.ratePlans[0]?.description}}
                                       </td>
                                 
                                  <td class=""style="padding: 8px;  text-align: center;" >
                                 {{con?.passengerTitle}}  {{con?.firstName}}  {{con?.lastName}} <br>
                                 {{con.passengerType==="ADT"?("Adult"):con.passengerType==="CHD"?("Child"):con.passengerType==="INF"?("Infant"):''}} {{i+1}}
                                  </td>
                                  
    
                             
      
                                </tr>
                              </tbody>
                            </table> -->
                            <table class="styled-tables">
                              <thead>
                                <tr>
                                  <th style="padding: 8px; text-align: center;">
                                    <mat-icon class="pt-1" style="margin-right: 2px;">hotel</mat-icon>Room Type
                                  </th>
                                  <th *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                                    <mat-icon class="pt-1" style="margin-right: 2px;">restaurant</mat-icon>Meal Plan
                                  </th>
                                  <th *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                                    <mat-icon class="pt-1" style="margin-right: 2px;">restaurant</mat-icon>Services
                                  </th>
                                  <th style="padding: 8px; text-align: center;">
                                    <mat-icon class="pt-1" style="margin-right: 2px;">groups</mat-icon>Guest Name
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let room of mergedData">
                                  <td style="padding: 8px; text-align: center;">
                                    {{ room.roomType }}
                                  </td>
                                  <td *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                                    {{ room.mealPlan }}
                                  </td>
                                  <td *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms">
                                    <ul style="text-align: start;" >
                                      <!-- style="list-style: none;" -->
                                      <li  *ngFor="let amen of  orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0].amenities let t = index"  [hidden]=" t >= 2"> 
                                        <!-- <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free WiFi'">wifi</mat-icon>
                                        <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name==='Free self parking'"> local_parking</mat-icon>
                                        <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Breakfast buffet'">free_breakfast</mat-icon>
                                        <mat-icon style="font-size: 18px;padding-top:8px;" *ngIf="amen.name==='Free one-way airport transfer'"> transfer_within_a_station</mat-icon>
                                        <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name==='Free welcome drink'"> local_drink</mat-icon>
                 -->
                                        {{ amen.name }}
                
                                      </li>
                                      <li style="list-style: none;" *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0]?.amenities&&orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0]?.amenities.length>2"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>
                
                                      <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                                        <li *ngFor="let amen of orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0]?.rates[0].amenities "  > 
                                          {{ amen.name }}
                                        </li>
                                      </p-overlayPanel>
    
                                      </ul>
                                  </td>
                                  <td style="padding: 8px; text-align: center;">
                                    <div *ngFor="let guest of room.guests.assignedAdults">
                                      {{ guest}} <br>
                                      {{'Adult'}}
                                      <mat-divider ></mat-divider>
                                    </div>
                                    
                                    <div *ngFor="let guest of room.guests.assignedChildren">
                                      {{ guest.name }}  <br>
                                      {{'Child'}} <small>({{ guest.age }} Year Old )</small>
                                      <mat-divider></mat-divider>
  
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
      
                  </div> 

                  <div class="cancellation-policy" style="text-align: start;">
                    <h3 >Cancellation Policy</h3>
                    <table >
                        <thead>
                            <tr>
                                <th>Cancellation on or After</th>
                                <th>Cancellation on or Before</th>
                                <th>Cancellation Charges/Comments</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms">
                          <tr *ngFor="let cancellation of orderId?.repriceData?.selectedHotelOrder?.hotel?.mmtRooms[0].ratePlans[0]?.cancellationPolicy?.penalties">
                            <!-- <td>{{cancellation?.cancelOnOrAfter}}</td>
                            <td>{{cancellation?.cancelOnOrBefore}}</td>
                            <td>{{cancellation?.charges}}</td> -->
                            <td>{{cancellation?.startDate}}</td>
                            <td>{{cancellation?.endDate}}</td>
                            <td>{{cancellationType(cancellation?.penaltyValue,cancellation?.penaltyType)}}</td>
      
                          </tr>
                           
                        </tbody>
                        <tbody *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms">
                        <tr *ngFor="let cancellation of orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms[0].rates[0]?.cancel_penalties">
                          <td>{{dateFormateTime(cancellation?.start)}}</td>
                          <td>{{dateFormateTime(cancellation?.end)}}</td>
                          <td *ngIf="cancellation?.amount">{{cancellation?.amount||0}}{{cancellation?.currency||'INR'}}</td>
                          <td *ngIf="cancellation?.nights">{{cancellation?.nights||0}} Night</td>
                          <td *ngIf="cancellation?.percent">{{cancellation?.percent||0}} %</td>
                        </tr>
                        </tbody>
                    </table>
                    <small *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms" style="color: green;font-style: italic;">All times are in the local time zone</small>

                    <!-- <p>*Each booking is applicable of ₹8.20 per room per night non-refundable service fees.<br>
                       *No Show will attract full cancellation charge unless otherwise specified.<br>
                       *Early check out will attract full cancellation charge unless otherwise specified.</p> -->
                </div>

                <div style="text-align: start;">
                <strong *ngIf="orderId.hotelBookingRequest?.hotelBookingRequest?.specialRequest" class="mt-1">Special request(s):</strong>
                <ul *ngIf="orderId.hotelBookingRequest?.hotelBookingRequest?.specialRequest">
                  <li *ngFor="let data of specialArray(orderId.hotelBookingRequest?.hotelBookingRequest?.specialRequest)">
                   {{data}}
                  </li></ul>
                  </div>
                <div style="text-align: start;">

                <div   class="col-md-12 mt-2" *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.checkInInstruction"><span style="color: #48504e; font-size: 16px; font-weight: 400;line-height: 26px;" ><strong>Check In Instruction : </strong ><br><span [innerHTML]='orderId?.repriceData?.selectedHotelOrder?.hotel?.checkInInstruction'></span></span></div>
                  <div   class="col-md-12 mt-2" *ngIf="orderId?.repriceData?.selectedHotelOrder?.hotel?.checkInSpecialInstruction"><span style="color: #48504e; font-size: 16px; font-weight: 400;line-height: 26px;" ><strong>Check In Special Instruction : </strong >{{orderId?.repriceData?.selectedHotelOrder?.hotel?.checkInSpecialInstruction}}</span></div>
                </div>
                <div class="booking-notes" style="text-align: start;">
                    <h3>Policies<br></h3>
                    
                    
                    <div *ngFor="let policy of orderId?.repriceData?.selectedHotelOrder?.hotel.mmtPolicies" class="policy-card">
                      <h5 class="category-title" style="color: rgb(99, 99, 99);">{{ policy?.category }}</h5>
                      <ul  class="amenity-list">
                        <li class="amenity-item"  *ngFor="let policyList of policy.policyList">
                          <i class="amenity-icon fas fa-check"></i>
                          <span class="amenity-name"> {{ policyList }}</span>
                  
                         
                        </li>
                      </ul>
                    </div>
  
                      
                </div>


                  </div>
                  <!-- <mat-form-field>
                    <mat-label>Name</mat-label>
                    <input matInput placeholder="Last name, First name" formControlName="firstCtrl" required>
                  </mat-form-field>  -->
                  <div *ngIf="showNext && pnrData && currentStep===2" class="box-container mb-4">
              
                    <div class="container">
                      <div class="col-md-12 row" >
                        
                      <div class="col-md-4 row"> 
                       <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">person</mat-icon></div>
                      <div class="col-md-9 d-flex justify-content-start"><strong>Client Name <br><span style="font-weight: 400;" class="d-flex justify-content-start">{{ pnrData?.clientName||'' }}</span></strong>
                      </div>
                      </div>
                      <div class="col-md-4 row"> 
                        <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">work</mat-icon></div>
                        <div class="col-md-9  " style="text-align: left;"><strong>Trip Cart Id <br><span style="font-weight: 400;" >{{ pnrData?.orderId }}</span></strong>
                        </div>

                      </div>
                      <div class="col-md-4 row"> 

                        <div  class="col-md-3" ><mat-icon style="font-size: 38px;  padding: 5px 35px 35px 35px;">card_membership</mat-icon></div>
                        <div class="col-md-9 d-flex justify-content-start"><strong>Foreign Trip Id <br><span style="font-weight: 400;" class="d-flex justify-content-start">{{ '' }}</span></strong>
                        </div>
                      </div>


                        <!-- <p>Your PNR ({{pnrNo}}) has been successfully generated.</p> -->

                      </div> </div> 
                    
                    
                    </div>
                 
                    <div *ngIf="showNext && pnrData && currentStep===2" style=" height:40vh;overflow-y: auto; overflow-x:hidden; ">
                    <div   class="box-container mb-4" *ngFor="let itinerary of pnrData.invoiceItineraryList">
              
                      <div class="container ">
                        <div class="ticket-container" >
                          <div class="ticket-header" >
                            
                            <div class="row col-md-12 row">
                            <div class="d-flex justify-content-start col-md-6"><mat-icon> local_airport</mat-icon>{{itinerary?.fromCity}}-{{itinerary?.toCity}} <span style="background-color: brown;color:white; border-radius:2px;padding-right:3px;padding-left:3px ;margin-left: 10px;">{{itinerary?.invoiceFlightDetails[0]?.scheduleDepartureDay}}</span>
                           <div class="d-flex justify-content-center col-md-6">
                         <span style="padding-right: 10px;">Airline PNR </span>  <strong>{{ itinerary?.itineraryPNR}}</strong>
                           </div>
                            </div>
                          </div>
                          </div>
                          <div  *ngFor="let item of itinerary.invoiceFlightDetails">
                            <div class="col-md-12 row"> 
                              
                               
                        
                            <div class="col-md-3 mt-3"> <div class="col-md-12 ">
                             
                              <div class="col-md-12 d-flex justify-content-start">
                                <img  class="carrier-logo" [src]="flightlogoFilter(item?.carrierName)"  alt="">

                              
                                <strong style="padding-left: 4px;">{{fligthNameFilter(item?.carrierName)}}</strong></div>
                    
                              <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> {{item?.carrierName }} - {{ item?.flightNumber }}</div>
                    
                            </div>
                            
                          </div>
                          <div class="col-md-9">

                            <div class="trip-details-container">
                              <div class="panel mt-3"  >
                                <!-- <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
                                  <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div></div>
                                  <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
                            
                                <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div></div>
                              </div> -->
                               
                            
                                <div  class="panel-content">
                                  <div class="flights " >
                            
                                   
                                  
                                    
                                  </div>
                            
                                  
                                </div>
                                <div class="col-md-12 row"> 
                                  
                                  <div class="col-md-4 "><div class="col-md-12  d-flex justify-content-start" style="font-size: 14px;">{{item?.scheduleDepartureDay}}</div><div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div><div class="col-md-12 d-flex justify-content-start">{{item?.scheduleDepartureTime }}</div><div class="col-md-12  d-flex justify-content-start" style="font-size: 14px;">{{item?.departureAirPort}}</div><div class="col-md-12 d-flex justify-content-start">{{item?.departureTerminal?("Terminal&nbsp;"+item?.departureTerminal):''}}</div></div>
                                  <div class="col-md-4  flight-number "><!-- ⌚ {{ "" }} -->

                                   <mat-icon class="mt-2">flight_takeoff</mat-icon>

                                  </div>
                            
                                <div class="col-md-4   "><div class="col-md-12  d-flex justify-content-end" style="font-size: 14px;">{{item?.scheduleArrivalDay}}</div><div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div><div class="col-md-12 d-flex justify-content-end">{{ item?.scheduleArrivalTime}}</div><div class="col-md-12  d-flex justify-content-end" style="font-size: 14px;">{{item?.arrivalAirPort}}</div><div class="col-md-12 d-flex justify-content-end">{{item?.arrivalTerminal?("Terminal&nbsp;"+item?.arrivalTerminal):''}}</div></div>
                              </div>
                                
                              </div>
                            
                              
                            
                              
                            </div>

                          </div>
                          <mat-divider></mat-divider>




                          





                    
                          </div>
                          <!-- <div class="ticket-passenger-details">
                            <h3>Passenger Details:</h3>
                            <ul>
                              <li *ngFor="let passenger of pnrData.passengerDetails">
                                {{ passenger?.passengerType }} - {{ passenger?.firstName }} {{ passenger?.lastName }}
                              </li>
                            </ul>
                          </div> -->
                          <div class="ticket-itinerary-details" >
              
                           

                              <div  >


              
                                
                              </div>
                            
                          </div>
                        </div>
                          


                        <div  *ngFor="let item of itinerary.itineraryPassengers">
                          <div class="col-md-12 row"> 
                            
                             
                      
                          <div class="col-md-3 mt-3"> <div class="col-md-12 ">
                           
                            <div class="col-md-12 d-flex justify-content-start">
                             <mat-icon>people</mat-icon>
                              <span style="padding-left: 4px;font-size: 14px;font-weight: bold;" >{{item?.title}} {{item?.firstName}} {{item?.lastName}}</span></div>
                  
                            <div class="col-md-12  d-flex justify-content-start " style="padding-left: 28px;"> {{item?.type==='ADT'?('Adult'):""}} {{item?.type==='CNN'?('Child'):""}} {{item?.type==='CHD'?('Child'):""}} {{item?.type==='INF'?('Infent'):""}}</div>
                  
                          </div>
                          
                        </div>
                        <div class="col-md-9">

                          <div class="trip-details-container">
                            <div class="panel mt-3"  >
                              <!-- <div class=" flex flex-middle flex-between   row" style="background-color: #1876D1; border-radius: 4px;min-height:50px;color:white"> 
                                <div class="col-md-4 "><div class="col-md-12 bold d-flex justify-content-start">{{item?.departureCity}}</div></div>
                                <div class="col-md-4  d-flex justify-content-center "> <mat-icon class="mt-2">flight_takeoff</mat-icon></div>
                          
                              <div class="col-md-4   "><div class="col-md-12 bold d-flex justify-content-end">{{item?.arrivalCity}}</div></div>
                            </div> -->
                             
                          
                              <div  class="panel-content">
                                <div class="flights " >
                          
                                 
                                
                                  
                                </div>
                          
                                
                              </div>
                              <div class="col-md-12 row"> 
                                
                                <div class="col-md-4 ">
                                  <div class="col-md-12 bold d-flex justify-content-start" style="font-size: 16px;">{{item?.pnr}}</div>
                                  <div class="col-md-12  d-flex justify-content-start" style="font-size: 14px;">Airline PNR</div>

                                <!-- <div class="col-md-12 mt-3 d-flex justify-content-start bold" style="font-size: 16px;">{{item?.totalPrice?(item?.totalPrice+' INR'):'' }} </div> -->
                                
                                <div class="col-md-12 mt-3 d-flex justify-content-start bold" style="font-size: 16px;">{{formatTotalPrice(item?.totalPrice) }} </div>

                                <div class="col-md-12  d-flex justify-content-start " style="font-size: 14px;">Total Price</div>

                              </div>
                                <div class="col-md-4  flight-number "><!-- ⌚ {{ "" }} -->

                                  <div class="col-md-12  d-flex justify-content-center bold" style="font-size: 16px;">{{item?.ticket==='0'?('N/A'):item?.ticket===0?('N/A'):item?.ticket===null?('N/A'):item?.ticket}}</div>
                                  <div class="col-md-12 d-flex justify-content-center " style="font-size: 14px;">Ticket No</div>

                                </div>
                          
                              <div class="col-md-4   ">
                                <div class="col-md-12  d-flex justify-content-end bold" style="font-size: 16px;">{{item?.bookingClass}}</div>
                                <div class="col-md-12 d-flex justify-content-end " style="font-size: 14px;">Class</div>

                              </div>
                            </div>
                              
                            </div>
                          
                            
                          
                            
                          </div>

                        </div>
                        <mat-divider></mat-divider>




                        





                  
                        </div>
                        <!-- <div class="ticket-passenger-details">
                          <h3>Passenger Details:</h3>
                          <ul>
                            <li *ngFor="let passenger of pnrData.passengerDetails">
                              {{ passenger?.passengerType }} - {{ passenger?.firstName }} {{ passenger?.lastName }}
                            </li>
                          </ul>
                        </div> -->
                        <div class="ticket-itinerary-details" >
            
                         

                            <div  >


            
                              
                            </div>
                          
                        </div>
                      </div>





                        </div></div>
              </div>
              
              </div>
              
                  <div *ngIf="!showNext&&currentStep===1" class="box-container ">
              
                      <div class="container">
              
                <div class="title">
                    <div class="row">
                     <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "   style="padding-left:20px;"></div></div>  
                    <div class="col-md-7 d-flex justify-content-center">Payment Details</div>
                    <div class=" col-md-3 row ">
                      <div class="d-flex justify-content-end">
                      <button class="btn btn-outline-primary btn-sm "(click)="onClickGstInfo()" >GST Information
                        <img src="assets/images/Add_24.png"></button>
                    </div>
                     </div>
                   </div>
                  </div>
                  <div *ngIf="showGstInfo" class="row mt-3" >
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Number</mat-label>
                      <input matInput type="text"  readonly  name="gstNumber" [ngModel]="billingEntity?.entityGST" autocomplete="off" >
  
                    </mat-form-field> 
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Name</mat-label>
                      <input matInput type="text" readonly  name="gstName" [ngModel]="billingEntity?.gstName" autocomplete="off" >
  
                    </mat-form-field>  
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Email</mat-label>
                      <input matInput type="text"  [ngModel]="billingEntity?.email" readonly name="gstEmail" autocomplete="off" >
  
                    </mat-form-field>
                    <mat-form-field class="col-md-3" appearance="outline">
                      <mat-label>GST Phone No.</mat-label>
                      <input matInput type="text" (keypress)="onlyNumberKey($event)" [ngModel]="billingEntity?.phone" readonly name="gstPhone" autocomplete="off" >
  
                    </mat-form-field>   
                  </div>
              <div class="col-md-12 row">
              <div class="payment-options col-md-9">
              
              <mat-selection-list   [multiple]="false"  #PaymentType   (selectionChange)="OrderId()">
                <span *ngFor="let medium of orderId.paymentConfig.status" >
              <mat-list-option  *ngIf="medium.isBusinessEnabled&&medium.mediumName!='PG'" isBusinessEnabled [color]="'primary'"   [value]="medium.mediumName" 
              checkboxPosition="before"><span >{{medium.mediumName}}</span>&nbsp;&nbsp;<mat-icon *ngIf="medium.mediumName!='VIRTUAL_CARD'" style="padding-top: 4px; margin-left: 10px;"  matTooltipPosition="above" (mouseenter)="GetBalance()" class="pointer"
                [matTooltip]="medium.mediumName==='DEPOSIT'?(totalBalance?.totalDepositAmount?(totalBalance?.totalDepositAmount+' INR'):'N/A'):medium.mediumName==='CREDIT'?(totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount+' INR'):'N/A'):'N/A'"
                matTooltipHideDelay="100" matTooltipHideDelay="0">remove_red_eye</mat-icon>

              </mat-list-option>
              <div *ngIf="medium.isBusinessEnabled&&medium.mediumName!='PG'" style="font-size: 14px;">The cost of this ticket will be charged to your company account maintained with us.</div>

            </span>
              <!-- <mat-list-option    value="credit"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Credit</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
                matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
              </mat-list-option>
            <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span>
            <mat-list-option    value="card"   [color]="'primary'" checkboxPosition="before"><span (click)="openTooltip()" >Card</span>&nbsp;&nbsp;&nbsp;&nbsp;<mat-icon style="padding-top: 4px;margin-left:10px" matTooltipPosition="above" (mouseenter)="GetBalance()"  [matTooltip]="totalBalance?.totalCreditAmount?(totalBalance?.totalCreditAmount +' INR'):'0 INR'"
              matTooltipHideDelay="100" matTooltipHideDelay="0" class="pointer">remove_red_eye</mat-icon>
            </mat-list-option>
          <span style="font-size: 14px;"> The cost of this ticket will be charged to your company account maintained with us.</span> -->
            <div class="row">

           
              <mat-form-field *ngIf="fopType==='VIRTUAL_CARD'" class=" required col-md-12 form-group mt-2" appearance="outline">
                <mat-label>Cards</mat-label>
                <mat-select   matNativeControl name="card" [(ngModel)]="cardNo"  (selectionChange)="cardData($event)"  >
                  <mat-option *ngFor="let item of CreditData" [value]="item.maskedCardNumber"   >{{item?.maskedCardNumber}}</mat-option>
                </mat-select>
                </mat-form-field>
              </div>
              </mat-selection-list>
              </div>
              <div class="mt-3 mb-2   col-md-3">
                
              </div>
              </div>
              
              
              </div>
              </div>
              
             
              <mat-divider class="mt-3 mb-3"></mat-divider>
              
                  <div  class="d-flex justify-content-start">
              
              <!-- <button *ngIf="!showNext&&currentStep===3"  mat-raised-button color="accent" style="margin-right: 8px;" (click)="backClick()">
              
              <mat-icon>arrow_back</mat-icon>Back
               </button> -->
               <button *ngIf="!showNext&&currentStep===1"  mat-raised-button color="accent" style="margin-right: 8px;" (click)="stepClick(3)">
              
                <mat-icon>arrow_back</mat-icon>Back
                 </button>
                 <div class="row" *ngIf="!showNext&&currentStep===3" >
                  <mat-checkbox class="d-flex justify-content-start"  *ngIf="loginUserType!='STAFF'&&orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms"
                  (change)="onSupplierCheckboxChange($event,'supplier')"
                  click="supplierAcknowledge=!supplierAcknowledge" [color]="'primary'" >
                  <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank">Supplier Terms & Conditions:</a> Please review and accept.
                </mat-checkbox>
                 <mat-checkbox class="d-flex justify-content-start"  *ngIf="loginUserType==='STAFF'&&orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms"
                 (change)="onSupplierCheckboxChange($event,'supplier')"
   
                 click="supplierAcknowledge=!supplierAcknowledge" [color]="'primary'" >
                 <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank">Supplier Terms & Conditions:</a> Please review and accept.
               </mat-checkbox>
               <mat-checkbox class="d-flex justify-content-start"  *ngIf="loginUserType==='STAFF'&&orderId?.repriceData?.selectedHotelOrder?.hotel?.expediaRooms"
                 (change)="onAgentCheckboxChange($event,'agent')"
   
                 click="supplierAcknowledge=!supplierAcknowledge" [color]="'primary'" >
                 <a href="http://developer.ean.com/terms/agent/en/" target="_blank">Terms & Conditions For Agent</a>: Please review and accept.
               </mat-checkbox>
                 <mat-checkbox  class="d-flex justify-content-start" 
                 (change)="onguestCheckboxChange($event,'guest')"
   
                 click="guestAcknowledge=!guestAcknowledge" [color]="'primary'" >
                 I acknowledge that I am booking the aforesaid room type and meal plan for my guest(s).
               </mat-checkbox>
              </div>
               <button *ngIf="!showNext&&currentStep===3" (click)="stepClick(1)" [disabled]="acknowledge" mat-raised-button color="accent" style="margin-left: 8px;width: 150px;" >
              
                <mat-icon>arrow_forward</mat-icon>Next
                 </button>
                 
              <span *ngIf="!showNext&&currentStep===1&&tripEnable===false">
                <button  *ngIf="!showSpiner && fopType==='VIRTUAL_CARD'" mat-raised-button color="accent" (click)="booking()" [disabled]="!fopType||!cardNo"> Book Hotel</button>

                <button  *ngIf="!showSpiner && fopType!='VIRTUAL_CARD'" mat-raised-button color="accent" (click)="booking()"[disabled]="!fopType" > Book Hotel</button>
                <!-- acceptTerm==='false' -->
               <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
              </span>

              <span *ngIf="!showNext&&currentStep===1&&tripEnable===true">
                <button  *ngIf="!showSpiner && fopType==='VIRTUAL_CARD'" mat-raised-button color="accent" (click)="submitRequest()" routerLink="/app/trip-summary" [disabled]="!fopType||!cardNo"> Submit Request</button>

                <button  *ngIf="!showSpiner && fopType!='VIRTUAL_CARD'" mat-raised-button color="accent" (click)="submitRequest()" routerLink="/app/trip-summary"[disabled]="!fopType" > Submit Request</button>
                <!-- acceptTerm==='false' -->
               <button  *ngIf="showSpiner"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
              </span>
            
              
              <!-- <span *ngIf="!pnrData">
              <button  *ngIf="showNext && !showMore" mat-raised-button color="accent"   (click)="pnrRetreive()"> More Details</button></span>
              <button  *ngIf="showMore"  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  ><mat-spinner  diameter="30" ></mat-spinner></button>
               -->
                  </div>
                </form>
                         
              
                          </div>
            </div>
          
            <!-- <div class="buttons">
              <button (click)="prevStep()" class="dbutton" [disabled]="currentStep === 1">Previous</button>
              <button (click)="nextStep()"  class="dbutton" [disabled]="currentStep === 3">Next</button>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div  *ngIf="showNext" class="ticket-header">
      <div class="col-md-12 row">
       
          <div *ngIf="test" style="overflow-x:auto ;height: 80vh;">
            <!-- <app-test></app-test> -->




            <div *ngIf="pnrData" class="booking-container">

              <div class="booking-header sticky-tabs">
                  <span class="status on-hold" [style]="pnrData?.status==='Confirmed'?('color:green'):''">{{pnrData.status}}
                    <br><span class="booking-id">Cart ID: {{pnrData?.orderId}}</span>

                  </span>
                  <!-- <span class="booking-id">Booking ID: {{pnrData?.bookingId}}</span> -->

              </div>
              <div class="hotel-info row">
              <div class="col-md-8">
                  <h2 >{{pnrData?.invoiceItineraryList[0]?.hotelName}}
                     <span class="stars">
                     <small *ngFor="let start of starArray(pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.ratings[0]?.starRating)"> 
                            <img  src="../../../assets/images/star.png" width="18" height="18" alt="">
                            </small>
                  </span></h2>
                
                  <p>
                    <!-- {{orderId?.hotelDetail?.location}}<br> -->
                    {{pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.address}}<br>
                    Postal Code: {{pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.pinCode}}<br>

                    <!-- Last Cancellation Date: Mar 14, 2024 9:29 AM -->
                   </p>
                  </div>
                  <div class="col-md-4">
                  <h4>Fare Summary</h4>
                  <div *ngIf="pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms"  class="mt-2 row"  style="font-size: 12px; ">
                    <span class="col-md-8 pt-1">Base Fare</span>
    
                    <span class="col-md-4 pb-1 pt-1">
                      {{pnrData?.priceData?.totalBaseAmount}} INR
                      <!-- {{mmtBaseFare(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.basePrice,pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.couponDiscount,pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.hotelDiscount)||0}}&nbsp;INR -->
                    </span>
                    <mat-divider></mat-divider>
                    <span class="col-md-8 pt-1">Taxes & fees</span>
          
                    <span class="col-md-4 pb-1 pt-1">
                      {{pnrData?.priceData?.finalTaxes}} INR
                      <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.price?.totalTax||0}}&nbsp;INR -->
                    </span>
                    <mat-divider></mat-divider>
                    <span class="col-md-8 pt-1">MGMT FEE + GST</span>
      
                    <span class="col-md-4 pb-1 pt-1">
                      {{pnrData?.priceData?.hotelDetailCommercial?.charge?(pnrData?.priceData?.hotelDetailCommercial?.charge?.toFixed()):0}} + {{pnrData?.priceData?.hotelDetailCommercial?.tax?(pnrData?.priceData?.hotelDetailCommercial?.tax?.toFixed()):0}} INR
                      <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.charge?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.charge?.toFixed()):0}} + {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.tax?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.commercial?.tax?.toFixed()):0}} INR -->
                    </span>
                 
                    <mat-divider style="background-color: #1876D1;"></mat-divider>
                   <mat-divider></mat-divider>
                    <span class="col-md-8  pt-1">Total Price</span>
                    <span class="col-md-4 pb-1 pt-1">
                      {{pnrData?.priceData?.totalBookingAmount}} INR
                      <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.totalAmount}} INR -->
                    </span>
          
                  </div>

                  <div *ngIf="pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms"  class="mt-2 row"  style="font-size: 12px; ">
                    <span class="col-md-8 pt-1">Base Fare </span>
    <span class="col-md-4 pb-1 pt-1">{{pnrData?.priceData?.totalBaseAmount}} INR</span>
                    <!-- <span class="col-md-4 pb-1 pt-1">{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.value?.toFixed()}}&nbsp;{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.currency||'INR'}}</span> -->
                     <mat-divider></mat-divider>
                     <span class="col-md-8 pt-1">Taxes & fees</span>
          
                    <span class="col-md-4 pb-1 pt-1" style="white-space: nowrap;">
                      <!-- {{(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.inclusive?.request_currency?.value-pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.exclusive?.request_currency?.value)?.toFixed()||0}} &nbsp;{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}} -->
                      {{pnrData?.priceData?.finalTaxes}} INR
                      &nbsp;<mat-icon style="cursor: pointer;color:grey;padding-top: 8px;font-size: 18px;" (click)="text.toggle($event)">info</mat-icon></span>
                    <p-overlayPanel #text [style]="{ width: '30rem' }">
                      <div class="flex flex-column gap-3 w-25rem">
                        This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked.For more details, please see the <a href="https://developer.expediapartnersolutions.com/terms/en" target="_blank"> terms and conditions.</a>
                        </div>
                        </p-overlayPanel>
                    <mat-divider></mat-divider>
                     <span class="col-md-8 pt-1">property Fee</span>
          
                    <span class="col-md-4 pb-1 pt-1">
                      {{pnrData?.priceData?.propertyFee}} INR
                      <!-- {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.property_fees?.request_currency?.value?.toFixed()||0}}&nbsp;{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.marketing_fee?.request_currency?.currency||'INR'}} -->
                    </span>
                     <mat-divider></mat-divider>
                     <span class="col-md-8 pt-1">Affiliate Service Charge + GST</span>
                     <span class="col-md-4 pb-1 pt-1">{{pnrData?.priceData?.hotelDetailCommercial?.charge?(pnrData?.priceData?.hotelDetailCommercial?.charge?.toFixed()):0}} + {{pnrData?.priceData?.hotelDetailCommercial?.tax?(pnrData?.priceData?.hotelDetailCommercial?.tax?.toFixed()):0}} INR</span>

                     <!-- <span class="col-md-4 pb-1 pt-1">{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.charge?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.charge?.toFixed()):0}} + {{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.tax?(pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.commercial?.tax?.toFixed()):0}} INR</span> -->
                     <mat-divider style="background-color: #1876D1;"></mat-divider>
      
                     <span class="col-md-8 pt-1 bold">Total Price </span>
                     <span class="col-md-4 pb-1 pt-1 bold">{{pnrData?.priceData?.totalBookingAmount}} INR</span>

                    <!-- <span class="col-md-4 pb-1 pt-1 bold" >{{pnrData?.invoiceItineraryList[0].invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.totalPrice?.requestedCurrencyTotalPrice?.toFixed()||0}}&nbsp;INR</span> -->
                  </div>

                  </div>
                 
              </div>
              <div class="booking-details">
                  <div class="check-in-out">
                      <div class="check-in">
                          <span>Check in</span>
                          <span>{{pnrData?.invoiceItineraryList[0]?.checkInDate}}</span>
                      </div>
                      <div class="check-out">
                          <span>Check out</span>
                          <span>{{pnrData?.invoiceItineraryList[0]?.checkOutDate}}</span>
                      </div>
                      <div class="total-rooms">
                          <span>Total Rooms</span>
                          <span>{{pnrData?.invoiceItineraryList[0]?.roomCount}}</span>
                      </div>
                      <div class="total-stay">
                          <span>Total Stay</span>
                          <span>{{calculateStayNights(pnrData?.invoiceItineraryList[0]?.checkInDate,pnrData?.invoiceItineraryList[0]?.checkOutDate)}} </span>
                      </div>
                  </div>

                  <div class="col-md-12 mt-3" >
                        
                    <!-- <table class="styled-tables ">
                        <thead>
                          <tr >
                            <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> hotel</mat-icon>Room Type
                            </th>
                            <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> restaurant</mat-icon>Meal Plan</th>
                            <th style="padding: 8px;  text-align: center;"><mat-icon class="pt-1" style="margin-right: 2px;"> groups</mat-icon>Guest Name  </th>
                                 


                          </tr>
                        </thead>
                        <tbody>

                          
                          <tr *ngFor="let con of pnrData?.invoiceItineraryList[0]?.itineraryPassengers; let i=index">
                            <td class=""style="padding: 8px;  text-align: center;" >
                          
                              {{pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.name}}
                            </td>
                               <td class=""style="padding: 8px;  text-align: center;" >
                                
                                  {{pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.description}}
                                 </td>
                           
                            <td class=""style="padding: 8px;  text-align: center;" >
                           {{con?.passengerTitle}}  {{con?.firstName}}  {{con?.lastName}} <br>
                           {{con.type==="ADT"?("Adult"):con.type==="CHD"?("Child"):con.type==="INF"?("Infant"):''}} {{i+1}}
                            </td>
                            

                       

                          </tr>
                        </tbody>
                      </table> -->

                      <table class="styled-tables">
                        <thead>
                          <tr>
                            <th style="padding: 8px; text-align: center;">
                              <mat-icon class="pt-1" style="margin-right: 2px;">hotel</mat-icon>Room Type
                            </th>
                            <th *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                              <mat-icon class="pt-1" style="margin-right: 2px;">restaurant</mat-icon>Meal Plan
                            </th>
                            <th *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                              <mat-icon class="pt-1" style="margin-right: 2px;">restaurant</mat-icon>Services
                            </th>
                            <th style="padding: 8px; text-align: center;">
                              <mat-icon class="pt-1" style="margin-right: 2px;">groups</mat-icon>Guest Name
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let room of pnrData?.invoiceItineraryList">
                            
                            
                            <td *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                              {{ room?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.name  }}
                            </td>
                            <td *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                              {{ room?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.room_name   }}
                            </td>
                            <td *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms" style="padding: 8px; text-align: center;">
                              {{ room?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.ratePlans[0]?.description }}
                            </td>
                            <td *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms" style="padding: 8px; text-align: center;">
                              <ul style="text-align: start;" >
                                <!-- style="list-style: none;" -->
                                <li  *ngFor="let amen of  pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.rates[0].amenities let t = index"  [hidden]=" t >= 2"> 
                                  <!-- <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name.includes('WiFi')">wifi</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top: 8px;"  *ngIf="amen.name.includes('parking')"> local_parking</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name.includes('Breakfast','breakfast')">free_breakfast</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top:8px;" *ngIf="amen.name.includes('transfer')"> transfer_within_a_station</mat-icon>
                                  <mat-icon style="font-size: 18px;padding-top: 8px;" *ngIf="amen.name.includes('drink','Drinks')"> local_drink</mat-icon>
           -->
                                  {{ amen.name }}
          
                                </li>
                                <li style="list-style: none;" *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.rates[0]?.amenities&&pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.rates[0]?.amenities.length>2"><span  class="yes" style="cursor: pointer;" (click)="ameni.toggle($event)">...more</span></li>
          
                                <p-overlayPanel #ameni [style]="{ width: '30rem' }">
                                  <li *ngFor="let amen of pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.rates[0].amenities "  > 
                                    {{ amen.name }}
                                  </li>
                                </p-overlayPanel>

                                </ul>                                         
                               </td>

                            <td style="padding: 8px; text-align: center;">
                              <div *ngFor="let guest of room.itineraryPassengers ">
                                {{ guest?.title}}  {{ guest?.firstName}}  {{ guest?.lastName}} <br>
                                <!-- {{'Adult'}} -->
                                {{guest.type==="ADT"?("Adult"):guest.type==="CHD"?("Child"):guest.type==="INF"?("Infant"):''}}
                                <mat-divider ></mat-divider>
                              </div>
                              
                             
                            </td>
                          </tr>
                        </tbody>
                      </table>


            </div> 

                  <div class="room-info" *ngIf="pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.mmtRooms" >
                
                    <p *ngIf="pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.mmtRooms[0].metadata.roomSize" class=""><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.metadata?.roomSize?(pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.metadata?.roomSize+"sq.ft"):"" }}</small></p> 
                    <p class=""  *ngFor="let bed of pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0]?.metadata?.beds"><small style="white-space: nowrap;"><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{bed.count}}&nbsp;{{bed.type}} </small></p> 
                   
                  </div>
                  <div class="room-info" *ngIf="pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms" >

                    <div class="" *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.metadata?.area"><small><mat-icon class="pt-1" > square_foot</mat-icon>&nbsp;{{pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms[0]?.metadata?.area.square_meters?(pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms[0]?.metadata?.area?.square_meters?(pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.metadata?.area?.square_meters+'sq.mtr'):pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms[0]?.metadata?.area?.square_feet?(pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms[0]?.metadata?.area?.square_feet+'sq.ft'):''):"" }}</small></div> 
                    <div class="" *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0]?.metadata?.bed_groups[0]?.id"><small><mat-icon class="pt-1"> hotel</mat-icon>&nbsp;{{pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms[0]?.metadata?.bed_groups[0]?.id?(pnrData.invoiceItineraryList[0].invoiceHotelDetails[0].hotel.expediaRooms[0]?.metadata?.bed_groups[0]?.id):''}} </small><small style="color: red;">(Bed type not guaranteed)</small></div>

                </div>
                 
              </div>
              <div class="special-requests">
                  <h3  *ngIf="pnrData?.specialRequest">Special request(s)</h3>
                  <!-- Add special requests here -->
                  <ul *ngIf="pnrData?.specialRequest">
                    <li *ngFor="let data of specialArray(pnrData.specialRequest)">
                     {{data}}
                    </li></ul>
              </div>
              <div class="contact-details">
                  <h3>Contact Details</h3>
                  <p>Email: {{pnrData?.email}}<br>
                     Mobile: {{pnrData?.contactNumber}}</p>
              </div>
              <div class="cancellation-policy">
                  <h3>Cancellation Policy</h3>
                  <table >
                      <thead>
                          <tr>
                              <th>Cancellation on or After</th>
                              <th>Cancellation on or Before</th>
                              <th>Cancellation Charges/Comments</th>
                          </tr>
                      </thead>
                      <tbody *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms">
                        <tr *ngFor="let cancellation of pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0].ratePlans[0]?.cancellationPolicy?.penalties">
                          <!-- <td>{{cancellation?.cancelOnOrAfter}}</td>
                          <td>{{cancellation?.cancelOnOrBefore}}</td>
                          <td>{{cancellation?.charges}}</td> -->
                          <td>{{cancellation?.startDate}}</td>
                          <td>{{cancellation?.endDate}}</td>
                          <td>{{cancellationType(cancellation?.penaltyValue,cancellation?.penaltyType)}}</td>
    
                        </tr>
                        
                      </tbody>
                      <tbody *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms">
                        <tr *ngFor="let cancellation of pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms[0].rates[0]?.cancel_penalties">
                          <td>{{dateFormateTime(cancellation?.start)}}</td>
                          <td>{{dateFormateTime(cancellation?.end)}}</td>
                          <td *ngIf="cancellation?.amount">{{cancellation?.amount||0}}{{cancellation?.currency||'INR'}}</td>
                          <td *ngIf="cancellation?.nights">{{cancellation?.nights||0}} Night</td>
                          <td *ngIf="cancellation?.percent">{{cancellation?.percent||0}} %</td>
                        </tr>
                        </tbody>
                  </table>
                  <small *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.expediaRooms" style="color: green;font-style: italic;">All times are in the local time zone</small>
               <span *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms">
                  <small  style="color: green;" *ngFor="let cancellation of cancellationFilter(pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtRooms[0].ratePlans[0]?.cancellationPolicy?.cancelPaneltyDesc)">
                    {{cancellation}}<br>
                  </small>
                </span>
                  <!-- <p>*Each booking is applicable of ₹8.20 per room per night non-refundable service fees.<br>
                     *No Show will attract full cancellation charge unless otherwise specified.<br>
                     *Early check out will attract full cancellation charge unless otherwise specified.</p> -->
              </div>
              <div class="booking-notes">
                  <h3>Booking Notes</h3>
                  <div class="text-align: start;">
                  <div   class="col-md-12 mt-2" *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.checkInInstruction"><span style="color: #48504e; font-size: 16px; font-weight: 400;line-height: 26px;" ><strong>Check In Instruction : </strong ><br><span [innerHTML]='pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.checkInInstruction'></span></span></div>
                    <div   class="col-md-12 mt-2 mb-1" *ngIf="pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.checkInSpecialInstruction"><span style="color: #48504e; font-size: 16px; font-weight: 400;line-height: 26px;" ><strong>Check In Special Instruction : </strong >{{pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.checkInSpecialInstruction}}</span></div>
                    </div>
                  <h3>Policies<br></h3>
                  
                  
                  <div *ngFor="let policy of pnrData?.invoiceItineraryList[0]?.invoiceHotelDetails[0]?.hotel?.mmtPolicies" class="policy-card">
                    <h5 class="category-title" style="color: rgb(99, 99, 99);">{{ policy?.category }}</h5>
                    <ul  class="amenity-list">
                      <li class="amenity-item"  *ngFor="let policyList of policy.policyList">
                        <i class="amenity-icon fas fa-check"></i>
                        <span class="amenity-name"> {{ policyList }}</span>
                
                       
                      </li>
                    </ul>
                  </div>

                    
              </div>
          </div>
          </div>
          <div class="col-md-7 pt-2 d-flex justify-content-end">
            <button  *ngIf="trip2Enable==='enable'"  mat-raised-button color="#ffffff" style="margin-right: 8px;" routerLink="/app/trip-summary">
              <mat-icon> trip_origin</mat-icon>Go To Trip</button>
            <button   *ngIf="trip2Enable!='enable'" mat-raised-button color="#ffffff" style="margin-right: 8px;" (click)="generateTicket()">
              <mat-icon>print</mat-icon>Print Voucher</button>
               <button  *ngIf="trip2Enable!='enable'" mat-raised-button color="#ffffff" style="margin-right: 8px;" (click)="generatePDF()" >
                <mat-icon>download</mat-icon>Download Voucher</button>
              </div>
              <div class="col-md-5 d-flex justify-content-end">
      
                <button   mat-raised-button color="#ffffff" style="margin-right: 8px;"(click)="backFlight()">
                  <mat-icon>arrow_back</mat-icon>Back</button>
                </div>
      
                </div>
          </div>
          

